var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7152 24.425V19.58C29.7152 18.1519 29.7152 17.4378 29.4373 16.8923C29.1928 16.4125 28.8027 16.0224 28.3229 15.7779C27.7774 15.5 27.0634 15.5 25.6352 15.5H20.1952C18.7671 15.5 18.053 15.5 17.5076 15.7779C17.0277 16.0224 16.6376 16.4125 16.3932 16.8923C16.1152 17.4378 16.1152 18.1519 16.1152 19.58V28.42C16.1152 29.8481 16.1152 30.5622 16.3932 31.1077C16.6376 31.5875 17.0277 31.9776 17.5076 32.2221C18.053 32.5 18.7671 32.5 20.1952 32.5H22.9152M25.0402 29.95L26.7402 31.65L30.5652 27.825",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVp);
export default __webpack_public_path__ + "static/media/vp.9d2fd2a2d506daa0c099fcd3964def25.svg";
export { ForwardRef as ReactComponent };